import AxiosInterceptor from './axios_interceptor';
// import router from '@/router/index';
// import { useDialogStore } from '@/stores/dialog';

/**
 * @displayName monitoringLog
 * @description 성장판 모니터링 로그 등록
 * @param menuName 메뉴명
 * @param learningTypeCode 학습 유형 코드
 * @param examName 시험지명
 * @param groupIndex 진단 추천 그룹
 * @returns {Promise<AxiosResponse<any>|*>}
 */
const monitoringLog = async (params) => {
    console.log('monitoringLog');
    return await requestPost(`${process.env.VUE_APP_API_URL}/api/growth/monitoring/log`, params);
};

/**
 * axios request post
 * @displayName requestPost
 * @param url	URL String
 * @param data	Data JSON
 * @param headers	Headers JSON
 * @returns {Promise<AxiosResponse<any>|*>}
 */
const requestPost = async (url, data = {}, headers = null) => {
    try {
        const response = await AxiosInterceptor.post(url, data, headers);
        console.log('API Response[POST]: ', response);

        if (response.status === 200) {
            return response;
        } else {
            console.error('Request Success but HTTP Status Code is', response.status);
        }
    } catch (err) {
        console.error(`API Request err`, err);
        // router.push({
        // 	path: '/error',
        // 	redirect: '/error',
        // });
        // useDialogStore().openAlertDialog({
        // 	message: err,
        // });
        return Promise.resolve(err);
    }
};

/**
 * axios request get
 * @displayName requestGet
 * @param url	URL String
 * @param headers	Headers JSON
 * @returns {Promise<unknown>}
 */
// const requestGet = async (url, headers = null) => {
// 	try {
// 		const response = await AxiosInterceptor.get(url, headers);
// 		console.log('API Response[GET]: ', response);

// 		if (response.status !== 200) {
// 			console.log('Request Success but HTTP Status Code is', response.status);
// 			alert(`Request Success but HTTP Status Code is '${response.status}'`);
// 		} else {
// 			return response;
// 		}
// 	} catch (err) {
// 		console.error(`API Request err`, err);
// 		useDialogStore().openAlertDialog({
// 			message: err.message,
// 		});
// 		return Promise.resolve(err);
// 	}
// };

const KRTAPI = {
    monitoringLog,
};

export default KRTAPI;
